module.exports = __webpack_public_path__ + "catalog/items/electrical-panel/texturePanel.png";